import { render, staticRenderFns } from "./auditComicRecordCol.vue?vue&type=template&id=af19a000"
import script from "./auditComicRecordCol.vue?vue&type=script&lang=js"
export * from "./auditComicRecordCol.vue?vue&type=script&lang=js"
import style0 from "./auditComicRecordCol.vue?vue&type=style&index=0&id=af19a000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports